<div class="flx-modal" role="dialog" aria-modal="true" *ngIf="translate">
    <!-- header -->
    <div class="flx-modal__header">
        <h2>{{translate?.setup.integrations.oauth.sections.sec4.plural}}</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()" tooltipPosition="left">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body mp-body">
        <div class="note-no-border" [ngClass]="{'mb-3': data?.mode != 'add'}">
            <p style="font-style: italic;">
                {{translate?.setup.integrations.oauth.messages.please}}<span class="font-semiBold">&nbsp;{{translate?.setup.integrations.oauth.messages.securely}}&nbsp;</span>{{translate?.setup.integrations.oauth.messages.storeThe}}&nbsp;{{translate?.setup.integrations.oauth.fields.secretKey.plural}}.&nbsp;{{translate?.setup.integrations.oauth.messages.thisIsThe}}<span class="font-semiBold">&nbsp;{{translate?.setup.integrations.oauth.messages.only}}&nbsp;</span>{{translate?.setup.integrations.oauth.messages.timeDisplayed}}.
                {{translate?.setup.integrations.oauth.messages.ifYouLose}}&nbsp;{{translate?.setup.integrations.oauth.fields.secretKey.plural}},&nbsp;{{translate?.setup.integrations.oauth.messages.youCanGenerateNew}}.
            </p>

        </div>
        <div class="note-no-border" *ngIf="data?.mode == 'add'" style="font-style: italic;" [ngClass]="{'mb-3': data?.mode == 'add'}">
            <p>
                {{translate?.setup.integrations.oauth.messages.theCaps}}&nbsp;{{translate?.setup.integrations.oauth.fields.consumerKey.plural}}&nbsp;{{translate?.setup.integrations.oauth.messages.canBeViewed}}.
            </p>
        </div>

         <div class="status-field" *ngIf="data?.mode == 'add'">
            <label class="field-label">{{translate?.setup.integrations.oauth.fields.consumerKey.singular}}</label>

            <div class="field-row field-row--auto_colorpick mb-2">
                <input id="consumerKey" type="text" pInputText disabled [value]="getMaskedKey2(data?.clientId)" style="background:#ededfd"
                    readonly />
                <button class="btn-list-icon" [pTooltip]="translate?.general.buttons.copy.singular" tooltipPosition="top"
                    (click)="copyKey(data?.clientId)">
                    <i class="fa-regular fa-copy"></i>
                </button>
            </div>
        </div>

         <div class="status-field">
            <label class="field-label">{{translate?.setup.integrations.oauth.fields.secretKey.singular}}</label>

            <div class="field-row field-row--auto_colorpick mb-2">
                <input id="consumerKey" type="text" pInputText disabled [value]="getMaskedKey(data?.clientSecret)" style="background:#ededfd"
                    readonly />
                <button class="btn-list-icon" [pTooltip]="translate?.general.buttons.copy.singular" tooltipPosition="top"
                    (click)="copyKey(data?.clientSecret)">
                    <i class="fa-regular fa-copy"></i>
                </button>
            </div>

         </div>


    </div>
    <!-- footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white"
            (click)="modalRef.hide()">{{translate?.general.buttons.close.singular}}</button>
    </div>
</div>